import AutomationAgency from "./Components/automation_agency_site.tsx";
import "./App.css"

function App() {
  return (
    <AutomationAgency/>
  );
}

export default App;
